// extracted by mini-css-extract-plugin
export var parcelRow = "_t4-0";